/* ============
 * Mutation types for the account module
 * ============
 *
 * The mutation types that are available
 * on the auth module.
 */

export const LIST = 'LIST';
export const RECORD_CHANGE = 'RECORD_CHANGE'
export const CHANGE_USER_STATUS = 'CHANGE_USER_STATUS'

export default {
  LIST,
  RECORD_CHANGE,
  CHANGE_USER_STATUS,
};
